import type { SorterResult, SortOrder } from 'antd/es/table/interface';
import type { AntdTableParams } from 'shared/types';
import type { ApiSort, ApiSortOrder } from '../api/services/types';

const getApiSortOrder = (order?: SortOrder): ApiSortOrder | undefined => {
  if (!order) {
    return undefined;
  }

  return order === 'ascend' ? 'asc' : 'desc';
};

const prepareSort = <T>(
  sort: SorterResult<T> | SorterResult<T>[] | undefined | null,
  skipDeepDataIndex?: boolean,
): ApiSort<T> => {
  if (!sort) {
    return [];
  }

  if (Array.isArray(sort)) {
    return sort
      .filter((s) => s && s.field && s.order)
      .map((s) => [s.field as keyof T, getApiSortOrder(s.order)!]);
  }

  if (!sort.field || !sort.order) {
    return [];
  }

  if (skipDeepDataIndex && Array.isArray(sort.field)) {
    return [[sort.field[1] as keyof T, getApiSortOrder(sort.order)!]];
  }

  if (Array.isArray(sort.field)) {
    return [[sort.field.join('.') as keyof T, getApiSortOrder(sort.order)!]];
  }

  return [[sort.field as keyof T, getApiSortOrder(sort.order)!]];
};

export const prepareTableParams = <T>(
  tableParams: AntdTableParams<T>,
  skipDeepDataIndex?: boolean,
) => {
  const sort = prepareSort(tableParams.sorter, skipDeepDataIndex);
  const page = (tableParams.pagination?.current ?? 1) - 1;
  const size = tableParams.pagination?.pageSize ?? 10;

  return {
    sort,
    page,
    size,
  };
};
